import { render, staticRenderFns } from "./paySuc.vue?vue&type=template&id=24fb12c3&scoped=true&"
import script from "./paySuc.vue?vue&type=script&lang=js&"
export * from "./paySuc.vue?vue&type=script&lang=js&"
import style0 from "./paySuc.vue?vue&type=style&index=0&id=24fb12c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb12c3",
  null
  
)

export default component.exports